const images = {
    logo: require('../../assets/images/logo.svg').default,
    banner: require('../../assets/images/HPBDChangg.jpg'),
    banner2: require('../../assets/images/LamDauAnhDI.jpg'),
    banner3: require('../../assets/images/Xone.jpg'),
    advertisment: require('../../assets/images/quangcao.jpg'),
    zingchart: require('../../assets/images/ed251cf560be4747e7737b535c357f07.webp'),
    zingchart_week: require('../../assets/images/a75a4d7ecdbaf4880ef4c5c80f347a6b.webp'),
    choose_today: require('../../assets/images/0daf3bf36c5cb4ddde3626171ccbcf68.webp'),
    singer: require('../../assets/images/3ec5ae34f4ad4fcaab567c678d44ce86.webp'),
    trinhthangbinh: require('../../assets/images/749ba06d29317d07bdbd2617808b8a7f.webp'),
    onlyc: require('../../assets/images/onlyc.webp'),
    huongtram: require('../../assets/images/huongtram.webp'),
    min: require('../../assets/images/min.webp'),
    mrsiro: require('../../assets/images/mrsiro.webp'),
    v_pop: require('../../assets/images/v-pop.webp'),
    c_pop: require('../../assets/images/china-pop.webp'),
    us_uk: require('../../assets/images/us-uk.webp'),
    v_indie: require('../../assets/images/v-indie.webp'),
    k_pop: require('../../assets/images/k-pop.webp'),
};

export default images;
